import { render, staticRenderFns } from "./PhoneMockup.vue?vue&type=template&id=03646934&"
import script from "./PhoneMockup.vue?vue&type=script&lang=ts&"
export * from "./PhoneMockup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports